import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';

export class InviteDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.INVITE, apiHelper);
  }

  public inviteUser(user: any): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource();
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, user, headers, null);
  }

  public getInvite(id: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' + id;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }
  public getByEmail(email: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' + 'query/admin?email=' + encodeURIComponent(email);
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  public resend(id: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' + id + '/resend';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, null, headers, null);
  }

  public findPending(id: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' + id + '/pending';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }
}
